// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/Goods';
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

import Index from '@/views/shop/Index';

import Balance from '@/views/shop/Balance';

import Qp from '@/views/order/Qp';

import Tq from '@/views/order/Tq';

import Tuan from '@/views/order/Tuan';

import Charge from '@/views/order/Charge';

import Card from '@/views/money/Card';

import Withdrawal from '@/views/money/Withdrawal';

import Board from '@/views/device/Board';
import Air from '@/views/device/Air';
import Lock from '@/views/device/Lock';
import Transfer from '@/views/device/Transfer';

// 启用路由
Vue.use(Router);

// 路由守卫
const router = new Router({
    routes: [{
        path: '/',
        redirect: '/shop/Index',
        hidden: true,
        meta: {
            requireAuth: true
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/register',
        name: '注册',
        component: () => import('@/views/register'),
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/update',
        name: '修改密码',
        component: () => import('@/views/update'),
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/device/transfer',
        name: '设备划拨',
        component: Transfer,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
     {
        path: '/device/qxia',
        name: '雀侠设备划拨',
        component: () => import('@/views/device/Qxia'),
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/device/Xcjc',
        name: '设备划拨',
        component: () => import('@/views/device/Xcjc'),
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
     {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/shop/Index',
            name: '店铺管理',
            component: Index,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/order/Qp',
            name: '棋牌订单管理',
            component: Qp,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/order/Tq',
            name: '台球订单管理',
            component: Tq,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/order/Charge',
            name: '充值订单',
            component: Charge,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/order/Tuan',
            name: '团购券订单管理',
            component: Tuan,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/money/Card',
            name: '用户卡管理',
            component: Card,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/money/Withdrawal',
            name: '提现管理',
            component: Withdrawal,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/shop/Balance',
            name: '用户余额',
            component: Balance,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/device/Board',
            name: '智控设备',
            component: Board,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/device/Lock',
            name: '蓝牙门锁',
            component: Lock,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/device/Air',
            name: '空调伴侣',
            component: Air,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Config',
            name: '支付配置',
            component: Config,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/druid/login',
            name: '监控查询',
            component: druidLogin,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        }]
    }

    // {
    //     path: '/index',
    //     name: '首页',
    //     component: index,
    //     iconCls: 'el-icon-tickets',
    //     children: [{
    //         path: '/goods/Goods',
    //         name: '商品管理',
    //         component: Goods,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }, {
    //         path: '/machine/Machine',
    //         name: '机器信息管理',
    //         component: Machine,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }, {
    //         path: '/machine/MachineAisle',
    //         name: '货道信息管理',
    //         component: MachineAisle,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }, {
    //         path: '/pay/Order',
    //         name: '交易订单',
    //         component: Order,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }, {
    //         path: '/system/user',
    //         name: '用户管理',
    //         component: user,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }, {
    //         path: '/system/Module',
    //         name: '菜单管理',
    //         component: Module,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }, {
    //         path: '/system/Role',
    //         name: '角色管理',
    //         component: Role,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }, {
    //         path: '/system/Dept',
    //         name: '公司管理',
    //         component: Dept,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }, {
    //         path: '/system/Variable',
    //         name: '系统环境变量',
    //         component: Variable,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }, {
    //         path: '/system/Permission',
    //         name: '权限管理',
    //         component: Permission,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }, {
    //         path: '/machine/MachineConfig',
    //         name: '支付配置信息',
    //         component: MachineConfig,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }, {
    //         path: '/pay/Config',
    //         name: '支付配置',
    //         component: Config,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }, {
    //         path: '/druid/login',
    //         name: '监控查询',
    //         component: druidLogin,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }, {
    //         path: '/charts/statistics',
    //         name: '数据可视化',
    //         component: statistics,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }]
    // }
]
})

// 路由守卫 - 优化登录状态验证
router.beforeEach((to, from, next) => {
    // 检查多种登录状态标识
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    const loginToken = localStorage.getItem('logintoken')
    const isLoggedIn = !!(userInfo.token || loginToken)
    
    // 不需要登录授权的页面直接通过
    if (to.meta.requireAuth === false) {
        next()
        return
    }
    
    // 已登录用户访问登录页
    if (to.path === '/login' && isLoggedIn) {
        next('/shop/Index')
        return
    }

    // 根路径处理
    if (to.path === '/') {
        next(isLoggedIn ? '/shop/Index' : '/login')
        return
    }

    // 检查token是否存在或有效
    if (!isLoggedIn) {
        next({ path: '/login', query: { redirect: to.fullPath } })
        return
    }

    // 权限检查（仅针对需要认证的页面）
    if (isLoggedIn) {
        const adminRoutes = ['/money/Withdrawal', '/money/Card']
        const userRole = userInfo.role || 'user'
        
        if (adminRoutes.includes(to.path) && userRole !== 'admin') {
            alert('您没有权限访问该页面')
            next('/shop/Index')
            return
        }
    }

    next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js